export const iconFontAwesomeCodingWebAwesome = (
	<i className="fa-solid fa-web-awesome"></i>
);
